module.exports = __webpack_public_path__ + "media/100.60b5e960.mp3";